import { getConfig } from '@testing-library/dom';

function wrapEvent(cb, _element) {
    return getConfig().eventWrapper(cb);
}

export { wrapEvent };
